import { ClientQueryStatusEnum } from './client-query';
import { InternalCommentStatusEnum } from './internal-comment';
import { WorkpaperRoleEnum } from './workpaper';
import { OtherScheduleEntryOverview } from './other-schedule-entry';
import { UserOverview } from './user';

export enum OtherScheduleStatusEnum {
    AWAITING_REVIEW = 'AWAITING_REVIEW',
    REVIEWED = 'REVIEWED',
    ARCHIVED = 'ARCHIVED',
}

export enum OtherScheduleHistoryEvent {
    OS_CREATE = 'OS_CREATE',
    OS_DETAILS_UPDATE = 'OS_DETAILS_UPDATE',
    ENTRY_CREATE = 'ENTRY_CREATE',
    ENTRY_UPDATE = 'ENTRY_UPDATE',
    ENTRY_DELETE = 'ENTRY_DELETE',
    ENTRY_ATTACHMENT_UPDATE = 'ENTRY_ATTACHMENT_UPDATE',
    STATUS_CHANGE = 'STATUS_CHANGE',
    ASSIGNEE_ADD = 'ASSIGNEE_ADD',
    ASSIGNEE_REMOVE = 'ASSIGNEE_REMOVE',
}

export type OtherScheduleHistoryRecord = {
    eventType: OtherScheduleHistoryEvent;
    id: string;
    otherScheduleId: string;
    createdAt: Date;
    createdBy: string;
    message: string;
};

export type OtherScheduleFileOverview = { id: string; entries: { id: string; reference: number }[] };
export type OtherScheduleQueryOverview = { id: string; status: ClientQueryStatusEnum };
export type OtherScheduleCommentOverview = { id: string; status: InternalCommentStatusEnum };

export type OtherSchedule = {
    id: string;
    workpaperId: string;
    name: string;
    description?: string;
    status: OtherScheduleStatusEnum;
    createdAt: Date;
    updatedAt: Date;
    assigned: (UserOverview & { role?: WorkpaperRoleEnum })[];
    createdBy: UserOverview;
    entries: OtherScheduleEntryOverview[];
    files: OtherScheduleFileOverview[];
    clientQueries: OtherScheduleQueryOverview[];
    internalComments: OtherScheduleCommentOverview[];
};

export type OtherScheduleOverview = Pick<OtherSchedule, 'id' | 'name'>;

export type OtherScheduleStatistics = {
    awaitingReview: number;
    reviewed: number;
    archived: number;
};

export type OtherScheduleHistoryResult = {
    id: string;
    otherSchedule: OtherScheduleOverview;
    eventType: OtherScheduleHistoryEvent;
    message: string;
    createdAt: Date;
    createdBy: UserOverview;
};
